/**
 * Payments Table Configuration
 */

import React from 'react';
import moment from 'moment';
import DynamicCell from '../components/misc/DynamicCell';
import { formatCurrency } from '../utils/formatting';
import {
  formatPaymentStatus,
  getPaymentStatusColor,
} from '../utils/paymentUtils';

export const PAYMENTS_TABLE = {
  entity: 'payments',
  defaults: {
    pageSize: 10,
    visible: { id: false },
    orderBy: { field: 'createdate', dir: 'desc' },
    limit: 50,
  },
  columns: [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'createdate', headerName: 'Created Date', width: 200 },
    {
      field: 'event.name',
      headerName: 'Event Name',
      width: 200,
      renderCell: (params) => params.row.event.name,
    },
    {
      field: 'total',
      headerName: 'Amount',
      width: 150,
      valueGetter: (params) => params.row.total,
      renderCell: (params) => formatCurrency(params.row.total),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => {
        const label = formatPaymentStatus(params.value);
        const color = getPaymentStatusColor(params.value);
        return <span style={{ color, fontWeight: 600 }}>{label}</span>;
      },
    },
  ],
};
